var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ direction: _vm.$vs.rtl ? 'rtl' : 'ltr' })},[_c('feather-icon',{attrs:{"icon":"Edit3Icon","svgClasses":"h-5 w-5 mr-4 hover:text-primary cursor-pointer"},on:{"click":_vm.editRecord}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }